module.exports = __webpack_public_path__ + "static/media/calculate-03.4b9fd01a.svg";